import { Voucher, VoucherPreviewFile } from '../types'

export const getVoucherFiles = (voucher: Voucher) =>
  voucher?.fileReferences?.reduce((result: VoucherPreviewFile[], fileReference) => {
    const { fileId: id, url: src } = fileReference
    return id && src ? [...result, { id, src }] : result
  }, [])
